<template>
  <div class="index">
    <div class="nav centered">
        <router-link :to="{ name: item.name }"
        :key="item.name" class="nav-item is-tab" active-class="is-active"
        v-for="item in userMenu">{{item.title}}</router-link>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  data () {
    return {
      userMenu: []
    }
  },
  name: 'EventsNavbar',
  computed: {
    ...mapState(['menu', 'user'])
  },
  created () {
    this.userMenu = this.menu.events.filter(i => i.roles.includes(this.user.role))
  }
}
</script>



// WEBPACK FOOTER //
// Navbar.vue?0d65d022